import styled, { css } from 'styled-components'
import { FlexBox } from '@brg/ui'
import { LayoutConst } from 'core/modules/layout.module'

export const BlockRoot = styled.div<{ $inputMode: 'text' | 'textarea' }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
`

export const LabelLangRow = styled(FlexBox)`
  width: 100%;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  margin-bottom: 8px;
  gap: 12px;
`

export const LabelLeft = styled(FlexBox)`
  flex: 1;
  min-width: 0;
  align-items: center;
`

export const FieldTitle = styled.label<{ $required?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  cursor: pointer;
  flex-shrink: 0;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
  color: #909090;

  @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }

  ${(p) =>
    p.$required &&
    css`
      position: relative;
      padding-right: 10px;

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        content: '*';
        color: #c64839;
        font-weight: 600;
      }
    `}
`

export const InputColumn = styled.div`
  width: 100%;
  min-width: 0;
  position: relative;
`

export const StyledTextInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  border: none;
  border-radius: 3px;
  background: #f2f2f2;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;

  &::placeholder {
    font-size: 15px;
    line-height: 20px;
    color: #909090;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 1px #909090;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    &::placeholder {
      font-size: 13px;
      line-height: 16px;
    }
  }
`

export const StyledTextarea = styled.textarea`
  display: block;
  width: 100%;
  box-sizing: border-box;
  min-height: 120px;
  padding: 16px 16px 32px;
  border: none;
  border-radius: 3px;
  background: #f2f2f2;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;
  resize: vertical;
  scrollbar-width: thin;

  &::placeholder {
    font-size: 15px;
    line-height: 20px;
    color: #909090;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 1px #909090;
  }

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #909090;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 10px 16px 28px;
    font-size: 13px;
    line-height: 16px;

    &::placeholder {
      font-size: 13px;
      line-height: 16px;
    }
  }
`

export const CharCount = styled.span`
  position: absolute;
  right: 12px;
  bottom: 10px;
  font-size: 13px;
  line-height: 16px;
  color: #909090;
  pointer-events: none;
`
import styled, { css } from 'styled-components'
import { FlexBox } from '@brg/ui'
import { LayoutConst } from 'core/modules/layout.module'

export const BlockRoot = styled.div<{ $inputMode: 'text' | 'textarea' }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
`

export const LabelLangRow = styled(FlexBox)`
  width: 100%;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  margin-bottom: 8px;
  gap: 12px;
`

export const LabelLeft = styled(FlexBox)`
  flex: 1;
  min-width: 0;
  align-items: center;
`

export const FieldTitle = styled.label<{ $required?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  cursor: pointer;
  flex-shrink: 0;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
  color: #909090;

  @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }

  ${(p) =>
    p.$required &&
    css`
      position: relative;
      padding-right: 10px;

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        content: '*';
        color: #c64839;
        font-weight: 600;
      }
    `}
`

export const InputColumn = styled.div`
  width: 100%;
  min-width: 0;
  position: relative;
`

export const StyledTextInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  border: none;
  border-radius: 3px;
  background: #f2f2f2;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;

  &::placeholder {
    font-size: 15px;
    line-height: 20px;
    color: #909090;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 1px #909090;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    &::placeholder {
      font-size: 13px;
      line-height: 16px;
    }
  }
`

export const StyledTextarea = styled.textarea`
  display: block;
  width: 100%;
  box-sizing: border-box;
  min-height: 120px;
  padding: 16px 16px 32px;
  border: none;
  border-radius: 3px;
  background: #f2f2f2;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;
  resize: vertical;
  scrollbar-width: thin;

  &::placeholder {
    font-size: 15px;
    line-height: 20px;
    color: #909090;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 1px #909090;
  }

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #909090;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 10px 16px 28px;
    font-size: 13px;
    line-height: 16px;

    &::placeholder {
      font-size: 13px;
      line-height: 16px;
    }
  }
`

export const CharCount = styled.span`
  position: absolute;
  right: 12px;
  bottom: 10px;
  font-size: 13px;
  line-height: 16px;
  color: #909090;
  pointer-events: none;
`
